/**
 * The shell's "make a tool" handlers (`use-master-layout-shell.ts` and
 * `openMemoryNode`) for the workspace view below `MasterLayout`: the wall's
 * + menu makes a note or a terminal through the same handlers as the canvas
 * rail's frame tools. Absent without an open project.
 */
import { createContext, useContext } from "react";

export interface WorkspaceTools {
  onAddNote?: () => void;
  onAddTerminal?: () => void;
  onAddTaskboard?: () => void;
  onAddMemory?: () => void;
}

const NO_TOOLS: WorkspaceTools = {};

const WorkspaceToolsContext = createContext<WorkspaceTools>(NO_TOOLS);

export const WorkspaceToolsProvider = WorkspaceToolsContext.Provider;

export function useWorkspaceTools(): WorkspaceTools {
  return useContext(WorkspaceToolsContext);
}
